module.exports = __webpack_public_path__ + "assets/img/ywg.24e5001c.png";